import { CSSObject } from '@chakra-ui/react';
import woman from '../../../../../../assets/wellbet/images/header/woman.svg';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonBalanceProps: CustomButtonProps = {
  variant: 'unstyled',
  display: 'flex',
  fontSize: 'xs',
};

export const BoxBallance: CSSObject = {
  bg: 'gray.50',
  color: 'gray.800',
};

export const buttonDepositProps: CustomButtonProps = {
  bg: 'alpha.700',
  color: 'white',
  borderRadius: 'sm',
  boxShadow: 'md',
  textShadow: '0px 1px 3px #2c2c2c',
  fontSize: 'sm',
  w: 'full',

  sx: {
    '&&': {
      p: '0',
    },

    '& svg': {
      textShadow: '0px 1px 5px #2c2c2c',
    },

    _hover: { bg: 'alpha.800', color: 'white' },
    _active: { bg: 'alpha.500', color: 'white' },
  },
};

export const ButtonNavItem = (): CSSObject => ({
  color: 'gray.800',

  '&& > p': { transition: 'all 0.2s ease-in-out' },

  '&:hover, &:active': {
    p: { transform: 'translate(2px, 0)' },
    bg: 'gray.50',
  },
});

export const BoxMascotImage: CSSObject = {
  bgImage: `url(${woman})`,
  bgSize: '100%',
  bgPos: 'inherit',
  bgRepeat: 'no-repeat',
  zIndex: '-1',

  display: ['none', null, 'block'],

  w: ['40px', '40px', '80px'],
  h: ['40px', '40px', '65px'],
};

export const PopoverContentQA: CSSObject = {
  top: '-2',
};
